// extracted by mini-css-extract-plugin
export default {"inputFileImage":"styles_inputFileImage__AR6zM"};